export const environment = {
  production: false,
  url: 'https://uatservi2.tutenlabs.dev'
};
